import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext'; // 🔥 IMPORTANTE: Usar o hook real

interface ProtectedRouteProps {
    roles?: string[];
    requireSecretary?: boolean;
}

export const ProtectedRoute = ({ roles, requireSecretary = false }: ProtectedRouteProps) => {
    // Usamos o hook real que busca os dados da nossa API e do Provider central
    const { user, activeSecretary, loading } = useAuth();
    const location = useLocation();

    // 1. Tela de Carregamento Estilizada enquanto a API verifica o Cookie/Sessão
    if (loading) {
        return (
            <div className="flex flex-col items-center justify-center h-screen w-full bg-[#0b0f1a]">
                <div className="w-12 h-12 border-4 border-blue-600/20 border-t-blue-600 rounded-full animate-spin mb-4" />
                <span className="text-[10px] font-black uppercase tracking-[3px] text-slate-500 animate-pulse">
                    Verificando Credenciais...
                </span>
            </div>
        );
    }

    // 2. Se não estiver logado após o loading, redireciona para o login
    if (!user) {
        return <Navigate to="/" state={{ from: location }} replace />;
    }

    if(user.role === 'VIEWER' && !['/reports','/select-secretary'].includes(location.pathname))
        return <Navigate to="/reports" replace />;

    // 3. Verificação de permissão (Role-Based Access Control)
    // Nota: Verifique se o seu objeto user da API retorna 'role' ou 'roles'
    // Se o backend não enviar role, essa parte precisa ser ajustada
    const userRole = (user as any).role || '';
    if (roles && !roles.includes(userRole)) {
        return <Navigate to="/403" replace />;
    }

    if (requireSecretary && !activeSecretary) {
        return <Navigate to="/select-secretary" replace />;
    }

    // Se passou em tudo, renderiza a rota filha (Dashboard, Users, etc)
    return <Outlet />;
};
